import React from 'react';
import ObjectIconFilter from '../ObjectIconFilter/ObjectIconFilter';
import { FiFilter } from 'react-icons/fi';
import SearchBox from '../SearchBox';
import './TableHeader.css';
import classnames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { MdClose } from 'react-icons/md';
import { usePermissions } from '../../hooks/usePermissions';

export default function TableHeader({icon, title, filterOptions, selectedFilterOption, onChangeFilter
	,openFilterHandler, getFilterUrl, navigate, buttons
}) {
	const { search } = useLocation();
	const sp = new URLSearchParams(search); // /search?category=Shirts
	const query = sp.get('query') || 'all';
	const { canSee, canEdit, canCreate, canDelete } = usePermissions();

	/**
	 * Check if button should be enabled based on its type
	 * @param {string} type - Button type: 'create', 'see', 'edit', 'delete'
	 * @returns {boolean}
	 */
	const hasPermission = (type) => {
		switch (type) {
		case 'create':
			return canCreate();
		case 'see':
			return canSee();
		case 'edit':
			return canEdit();
		case 'delete':
			return canDelete();
		default:
			return true; // If no type specified, allow by default for backward compatibility
		}
	};
	return (
		<div className="table-header">
			<ObjectIconFilter
				icon={icon}
				title={title}
				types={filterOptions}
				selectedType={selectedFilterOption}
				onChangeType={onChangeFilter}
			/>

			<div className='table-header-actions'>
				{
					query !== 'all' && 
				<span className='query-result'>
										Resultados para: {query}
					<Link
						className='btn-primary-search'
						as={Link}
						to={getFilterUrl({ query: 'all' })}
					>
						<MdClose />
					</Link>
				</span>

				}
				<button
					className='filter-button'
					onClick={openFilterHandler}
				>
					<FiFilter />
				</button>

				<SearchBox getFilterUrl={getFilterUrl} navigate={navigate} />
				{
					buttons?.filter((button) => !button.type || hasPermission(button.type)).map((button, index) => {
						return (
							<button
								key={index}
								onClick={button.onClick}
								className={classnames('header-button', { icon: !button.label })}
							>
								{button.icon}
								{button.label}
							</button>
						);
					})
				}
			</div>
		</div>
	);
}

// {query !== 'all' ? (
// 	<Col>

// 	</Col>